import React, { memo } from 'react';
import { View, StyleSheet } from 'react-native';
import Theme from '@qnpm/q-theme';
import { dateUtil, performanceUtil } from '@qnpm/q-design-utils';
import Day from './Day';
import { computeColumnColor, dayDateCanSelect } from '../../utils/handle';
import { CALENDAR_TYPE } from '../../utils/constant';
const { qunar } = Theme.color.palette;
const DayList = (props) => {
    var _a, _b;
    const { data, onSelect, selectedDate = [], dayScale, rowID, blockID, mode = CALENDAR_TYPE.SINGLE, dataConfig = {}, computedStyle, accessibilityPreName, startTime, endTime, allowDates, denyDates, denyWeeks, refreshWidth } = props;
    const isRange = mode === CALENDAR_TYPE.RANGE;
    // 范围选择已完成
    const rangeSelectFinished = isRange && (selectedDate === null || selectedDate === void 0 ? void 0 : selectedDate.length) === 2;
    // 范围选择时，是否选择了同一天
    const isRangeRepeat = isRange && ((_a = selectedDate[0]) === null || _a === void 0 ? void 0 : _a.key) === ((_b = selectedDate[1]) === null || _b === void 0 ? void 0 : _b.key);
    return (<View style={[styles.dateRow, computedStyle.dayList.row]}>
            {data.map((row, columnID) => {
        var _a, _b, _c, _d;
        const { selectedIndex, key, showValue, value, selected, extra } = row;
        // 根据列数展示的颜色
        const textColor = computeColumnColor(columnID);
        // 选中时的背景色
        const selectedBackgroundColor = selected && !isRangeRepeat && rangeSelectFinished
            ? qunar.shade9
            : 'transparent';
        // 是否在给定日期范围内，只有展示出来的才校验
        const valid = showValue
            ? dayDateCanSelect({
                value,
                week: columnID,
                startTime,
                endTime,
                allowDates,
                denyDates,
                denyWeeks
            })
            : false;
        // 当前日期是否在选择的范围内（只有范围选择时需要计算）
        const included = showValue && isRange
            ? dateUtil.isWithinDayRange(value, {
                start: (_a = selectedDate[0]) === null || _a === void 0 ? void 0 : _a.value,
                end: (_b = selectedDate[1]) === null || _b === void 0 ? void 0 : _b.value
            })
            : false;
        return (<Day key={key} content={showValue} disabled={!valid} selected={selected} onPress={() => onSelect &&
            onSelect(row, { blockID, rowID, columnID })} computedStyle={computedStyle} accessibilityPreName={accessibilityPreName} data={{
            rowID,
            blockID,
            columnID,
            // 禁止时不存在包含状态
            included: included && valid,
            extra,
            value,
            selectedIndex,
            selectedBackgroundColor,
            config: dataConfig[value] || dataConfig[key],
            colors: {
                header: textColor,
                content: textColor
            },
            dayScale,
            isFirstSelected: ((_c = selectedDate[0]) === null || _c === void 0 ? void 0 : _c.key) === key,
            isLastSelected: ((_d = selectedDate[1]) === null || _d === void 0 ? void 0 : _d.key) === key
        }} refreshWidth={refreshWidth}/>);
    })}
        </View>);
};
export default memo(DayList, performanceUtil.fastDeepEqual);
const styles = StyleSheet.create({
    dateRow: {
        width: '100%',
        flexDirection: 'row'
    }
});
